export const productSelectedOptionClassName = [
  'pl-s',
  'pr-[11px]',
  'border',
  'border-gray-100',
  'bg-base-white',
  '!text-gray-900',
  'border-[1px]',
  'rounded-[6px]',
  'h-[44px]',
  'px-2s',
  'py-2xs',
  'shadow-[0_1px_3px_0_rgba(26,32,34,0.10),_0_1px_2px_0_rgba(26,32,34,0.06)]'
].join(' ');

export const productContentComputeClassName = [
  'z-20',
  'h-fit',
  'bg-white',
  'flex',
  'flex-col',
  'items-center',
  'w-full',
  'pb-[120px]'
].join(' ');

export const productContentClassName = [
  'z-20',
  'h-fit',
  'bg-white',
  'flex',
  'flex-col',
  'items-center',
  'w-full',
  'pb-[96px]'
].join(' ');

export const productListClassName = [
  'w-fit',
  'flex',
  'min-h-[calc(100%-84px)]',
  'relative',
  'justify-start',
  'flex-1',
  'text-base',
  'flex-col',
  'items-start',
  'h-full',
  'overflow-hidden',
  'ml-[calc((100%-1280px)/2)]',
  'py-10xl'
].join(' ');

export const productItemClassName = [
  'w-full',
  'grow-1',
  'shrink-0',
  'flex',
  'border',
  'border-gray-100',
  'rounded-[12px]',
  'flex-row',
  'p-3xs',
  'gap-4xs',
  'rounded-xl',
  'bg-gray-50',
  'text-gray-400',
  'font-semibold',
  'leading-xl',
  'items-center',
  'cursor-pointer'
].join(' ');

export const workloadDescTitleClassName = [
  'font-semibold',
  'text-5xl',
  'leading-18xl',
  'text-gray-900'
].join(' ');

export const workloadDescClassName = [
  'font-body',
  'font-regular',
  'text-xl',
  'leading-3xl',
  'text-secondary',
  'text-center'
].join(' ');

export const workloadItemClassName = [
  'flex',
  'flex-col',
  'w-[540px]',
  'border',
  'border-gray-100',
  'rounded-2xl',
  'bg-base-white',
  'p-7xl',
  'shadow-[0_12px_16px_-4px_rgba(26,32,34,0.08),_0_4px_6px_-2px_rgba(26,32,34,0.03)]'
].join(' ');

export const workloadItemChipClassName = [
  'px-xs',
  'py-5xs',
  'rounded-full',
  'bg-gray-50',
  'border',
  'border-gray-200',
  'text-gray-600',
  'text-sm',
  'font-medium',
  'leading-lg',
  'w-fit'
].join(' ');

export const workloadItemTitleClassName = [
  'font-semibold',
  'text-gray-900',
  'text-4xl',
  'leading-18xl',
  'mt-l',
  'mb-2xs'
].join(' ');

export const workloadPriceClassName = [
  'font-semibold',
  'text-cic-blue-500',
  'text-2xl',
  'leading-4xl'
].join(' ');

export const workloadContactUsClassName = [
  'w-full',
  'bg-cic-blue-500',
  'px-xl',
  'py-m',
  'text-base-white',
  'text-md',
  'font-semibold',
  'leading-sm'
].join(' ');

export const workloadOptionClassName = [
  'flex',
  'flex-row',
  'justify-start',
  'items-start',
  'text-xs',
  'font-regular',
  'leading-xs'
].join(' ');

export const comparionTableRowClassName = [
  'flex',
  'flex-row',
  'w-full',
  'bg-gray-50',
  'gap-0',
  'h-[68px]',
  'items-center',
  'text-md',
  'font-semibold',
  'leading-xl',
  'text-primary',
  'border-b',
  'border-gray-200'
].join(' ');

export const comparionTableCellClassName = [
  'flex',
  'flex-1',
  'px-3xl',
  'justify-center',
  'font-semibold'
].join(' ');

export const comparionTableFirstColClassName = [
  'flex',
  'px-3xl',
  'text-sm',
  'font-regular',
  'leading-xl',
  '!w-[300px]'
].join(' ');
